module.exports = __webpack_public_path__ + "img/logo1.fc5c3600.png";